export function mapSegmentsFromApi({ data, resourceIsNew = false }) {
  let maxPriority = 0
  const mapped = data.AvailableSegments.map(as => {
    const segment = defaultSegment({
      name: as.SegmentName,
      code: as.SegmentCode,
    })
    segment.isUsedByProducts = as.IsUsedByProducts
    segment.active = data.ActiveSegmentCodes.includes(as.SegmentCode) || resourceIsNew
    const segmentSettings = data.Segments.find(s => s.SegmentCode === as.SegmentCode)
    if (segmentSettings) {
      segment.exclusive = segmentSettings.Exclusive
      segment.capacity = segmentSettings.ModifiedCapacity
      segment.priority = segmentSettings.Priority
      if (segmentSettings.Priority > maxPriority) maxPriority = segmentSettings.Priority
    }
    return segment
  })
  let priority = maxPriority + 1
  for (const segment of mapped) {
    if (!segment.priority) segment.priority = priority++
  }
  return mapped
}

export function defaultSegment({ name, code, priority }) {
  return {
    name,
    code,
    exclusive: false,
    active: true,
    capacity: null,
    priority,
  }
}
